export default [
    {
        path: "/signups",
        name: "signups",
        component: () => import(/* webpackChunkName: "signups" */ "../views/signups/SignupList.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: "/signups/:id",
        name: "single_signup",
        props: true,
        component: () => import(/* webpackChunkName: "single_signup" */ "../views/signups/SingleSignup.vue"),
        meta: { requiresAuth: true }
    },
]